import {useMemo} from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import CustomCheckBox from 'js/components/shared/FormElements/CustomCheckBox';

import styles from './SortSelect.module.scss';

const cx = classnames.bind(styles);

const SortSelect = ({
  className,
  value,
  onChange,
  titles,
}) => {
  const items = useMemo(function () {
    return titles?.items.map((label, i) => ({
      label,
      id: i + 1,
      value: value === i + 1,
      onChange: function () {
        onChange && onChange(i + 1);
      }
    }));
  }, [titles, value]);

  return (
    <div className={cx('root', className)}>
      {items.map(el => (
        <CustomCheckBox
          key={el.id}
          className={cx('sort-item')}
          input={el.input}
          label={el.label}
          checked={el.value}
          onChange={el.onChange}
        />
      ))}
    </div>
  )
}

SortSelect.propTypes = {
  className: PropTypes.string,
}

export default SortSelect;
